export default function NoopHead() {
  return null
}
